import { useState } from "react";
import { Button, Col, Modal, ModalBody, Row } from "@/Components/ui";;
import { SITE_ID } from "../../../assets/meta/meta";
import { BACKEND_HOST } from "../../../api";
import axios from "axios";
import DaumPostcode from "react-daum-postcode";

const KakaoMapModal = (props) => {
  const togModal = () => {
    props.setVisible(!props.visible);
  };

  // const addressSearch = () => {
  //   new daum.Postcode({
  //     oncomplete: function (data) {
  //       // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

  //       // 각 주소의 노출 규칙에 따라 주소를 조합한다.
  //       // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
  //       var addr = ""; // 주소 변수
  //       var extraAddr = ""; // 참고항목 변수

  //       //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
  //       if (data.userSelectedType === "R") {
  //         // 사용자가 도로명 주소를 선택했을 경우
  //         addr = data.roadAddress;
  //       } else {
  //         // 사용자가 지번 주소를 선택했을 경우(J)
  //         addr = data.jibunAddress;
  //       }

  //       // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
  //       if (data.userSelectedType === "R") {
  //         // 법정동명이 있을 경우 추가한다. (법정리는 제외)
  //         // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
  //         if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
  //           extraAddr += data.bname;
  //         }
  //         // 건물명이 있고, 공동주택일 경우 추가한다.
  //         if (data.buildingName !== "" && data.apartment === "Y") {
  //           extraAddr += extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
  //         }
  //         // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
  //         if (extraAddr !== "") {
  //           extraAddr = " (" + extraAddr + ")";
  //         }
  //         // 조합된 참고항목을 해당 필드에 넣는다.
  //         document.getElementById("extraAddress").value = extraAddr;
  //       } else {
  //         document.getElementById("extraAddress").value = "";
  //       }

  //       // 우편번호와 주소 정보를 해당 필드에 넣는다.
  //       document.getElementById("postcode").value = data.zonecode;
  //       document.getElementById("address").value = addr;
  //       // 커서를 상세주소 필드로 이동한다.
  //       document.getElementById("detailAddress").focus();
  //       setAddress(data.address);
  //     },
  //   }).open();
  // };

  return (
    <Modal isOpen={props.visible} onClose={togModal} centered>
      <ModalBody>
        <DaumPostcode
          style={{}}
          onComplete={(data) => {
            props.setAddress(data.address);
            props.setVisible(!props.visible);
          }}
        ></DaumPostcode>
        {/* <Row className="align-items-center g-3 mx-2 my-3">
          <Col>
            <div className="d-flex mb-3 justify-content-between">
              <input disabled type="text" className="form-control w-50" id="postcode" placeholder="우편번호"></input>
            </div>
            <input type="text" className="form-control mb-3" onChange={(e) => setAddress(e.target.value)} id="address" placeholder="주소" disabled></input>
            <input type="text" className="form-control mb-3" id="detailAddress" onChange={(e) => setDetailAddress(e.target.value)} placeholder="상세주소"></input>
            <input disabled type="text" className="form-control w-25" id="extraAddress" placeholder="참고항목"></input>
          </Col>

          <div className="d-flex justify-content-end mb-3">
            {props.isNotice ? (
              <Button
                color="light ms-2"
                onClick={() => {
                  props.setAddress(address + detailAddress);
                  props.setVisible(!props.visible);
                }}
              >
                입력
              </Button>
            ) : (
              <Button
                color="light ms-2"
                onClick={() => {
                  updateCoordinate();
                  props.setVisible(!props.visible);
                }}
              >
                적용
              </Button>
            )}

            <Button
              color="light ms-2"
              onClick={() => {
                props.setVisible(!props.visible);
              }}
            >
              닫기
            </Button>
          </div>
        </Row> */}
      </ModalBody>
    </Modal>
  );
};

export default KakaoMapModal;
